var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    [
      _c("ReprogramarCronograma"),
      _vm._v(" "),
      _c("SolicitarEjecucionVacacion"),
      _vm._v(" "),
      _c("VerDetalleUsoVacacion"),
      _vm._v(" "),
      _c("VerDetalle"),
      _vm._v(" "),
      _c("VerReporte"),
      _vm._v(" "),
      _c("VerReprogramaciones"),
      _vm._v(" "),
      _c("EditarReprogramacionRechazada"),
      _vm._v(" "),
      _c(
        "h3",
        { staticClass: "primary--text" },
        [
          _c("v-icon", { attrs: { color: "primary" } }, [_vm._v("today")]),
          _vm._v(" Vacaciones programadas\n  ")
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-flex",
        { attrs: { xs12: "", md6: "" } },
        [
          _c("v-autocomplete", {
            attrs: {
              items: _vm.lista_gestiones,
              "item-text": "periodo",
              "item-value": "periodo",
              label: "Seleccione la gestión",
              required: "",
              outline: "",
              success: "",
              clearable: ""
            },
            on: {
              input: function($event) {
                return _vm.cargarVacacionesProgramadas(_vm.periodo_seleccionado)
              }
            },
            model: {
              value: _vm.periodo_seleccionado,
              callback: function($$v) {
                _vm.periodo_seleccionado = $$v
              },
              expression: "periodo_seleccionado"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-tooltip",
        { attrs: { bottom: "" } },
        [
          _c(
            "v-btn",
            {
              staticClass: "btn-refresh",
              attrs: { slot: "activator" },
              nativeOn: {
                click: function($event) {
                  return function() {
                    _vm.filterShow = !_vm.filterShow
                  }.apply(null, arguments)
                }
              },
              slot: "activator"
            },
            [_c("v-icon", [_vm._v("filter_list")])],
            1
          ),
          _vm._v(" "),
          _c("span", [_vm._v("Búsqueda/filtros")])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-tooltip",
        { attrs: { bottom: "" } },
        [
          _c(
            "v-btn",
            {
              staticClass: "btn-refresh",
              attrs: { slot: "activator" },
              nativeOn: {
                click: function($event) {
                  return _vm.cargarVacacionesProgramadas(
                    _vm.periodo_seleccionado
                  )
                }
              },
              slot: "activator"
            },
            [_c("v-icon", [_vm._v("refresh")])],
            1
          ),
          _vm._v(" "),
          _c("span", [_vm._v(_vm._s(_vm.$t("common.updateList")))])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-flex",
        { attrs: { xs12: "" } },
        [
          _c("transition", { attrs: { name: "slide-fade" } }, [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.filterShow,
                    expression: "filterShow"
                  }
                ],
                staticClass: "filter-container"
              },
              [
                _c("v-icon", { attrs: { small: "", color: "primary" } }, [
                  _vm._v("search")
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "filter-item" },
                  [
                    _c("v-text-field", {
                      attrs: { label: "Nro", type: "number" },
                      on: { input: _vm.filterSecuencia },
                      model: {
                        value: _vm.form.secuencia,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "secuencia", $$v)
                        },
                        expression: "form.secuencia"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "filter-item" },
                  [
                    _c("v-text-field", {
                      attrs: { label: "Fecha desde", type: "text" },
                      on: { input: _vm.filterFechaDesde },
                      model: {
                        value: _vm.form.fecha_desde,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "fecha_desde", $$v)
                        },
                        expression: "form.fecha_desde"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "filter-item" },
                  [
                    _c("v-text-field", {
                      attrs: { label: "Fecha hasta", type: "text" },
                      on: { input: _vm.filterFechaHasta },
                      model: {
                        value: _vm.form.fecha_hasta,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "fecha_hasta", $$v)
                        },
                        expression: "form.fecha_hasta"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "filter-item" },
                  [
                    _c("v-text-field", {
                      attrs: { label: "Días programados", type: "number" },
                      on: { input: _vm.filterTotalDias },
                      model: {
                        value: _vm.form.total_dias,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "total_dias", $$v)
                        },
                        expression: "form.total_dias"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "filter-item" },
                  [
                    _c("v-text-field", {
                      attrs: { label: "Tipo", type: "text" },
                      on: { input: _vm.filterTipo },
                      model: {
                        value: _vm.form.tipo,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "tipo", $$v)
                        },
                        expression: "form.tipo"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "filter-item" },
                  [
                    _c("v-text-field", {
                      attrs: { label: "Estado" },
                      on: { input: _vm.filterEstado },
                      model: {
                        value: _vm.form.estado,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "estado", $$v)
                        },
                        expression: "form.estado"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "btn-filter" },
                  [
                    _c(
                      "v-tooltip",
                      { attrs: { bottom: "" } },
                      [
                        _c(
                          "v-btn",
                          {
                            attrs: { slot: "activator", icon: "", small: "" },
                            nativeOn: {
                              click: function($event) {
                                return _vm.recargar()
                              }
                            },
                            slot: "activator"
                          },
                          [
                            _c("v-icon", { attrs: { small: "" } }, [
                              _vm._v("refresh")
                            ])
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("span", [_vm._v("Recargar filtros")])
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "v-tooltip",
                      { attrs: { bottom: "" } },
                      [
                        _c(
                          "v-btn",
                          {
                            attrs: { slot: "activator", icon: "" },
                            nativeOn: {
                              click: function($event) {
                                return function() {
                                  _vm.filterShow = false
                                }.apply(null, arguments)
                              }
                            },
                            slot: "activator"
                          },
                          [
                            _c("v-icon", { attrs: { small: "" } }, [
                              _vm._v("close")
                            ])
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("span", [_vm._v("Cerrar filtros")])
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-card",
        [
          _c(
            "v-card-text",
            [
              _c(
                "v-data-table",
                {
                  staticClass: "elevation-1 tabla-comprimida-light",
                  attrs: {
                    items: _vm.lista_vacaciones,
                    headers: _vm.headers,
                    "disable-initial-sort": true,
                    "item-key": "id",
                    loading: _vm.loading,
                    "no-data-text": "No se tiene registros",
                    "no-results-text": "No se encontraron coincidencias",
                    search: _vm.filters,
                    "custom-filter": _vm.customFilter,
                    "rows-per-page-items": [
                      20,
                      40,
                      { text: "Todos", value: -1 }
                    ]
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "items",
                      fn: function(items) {
                        return [
                          _c(
                            "tr",
                            {
                              staticClass: "text-xs-center",
                              attrs: {
                                id:
                                  items.item.tipo == "P"
                                    ? "celdaP"
                                    : items.item.tipo == "R"
                                    ? "celdaR"
                                    : items.item.tipo == "VC"
                                    ? "celdaVC"
                                    : "celdaFR"
                              }
                            },
                            [
                              _c("td", [_vm._v(_vm._s(items.item.secuencia))]),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(_vm._s(items.item.fecha_desde))
                              ]),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(_vm._s(items.item.fecha_hasta))
                              ]),
                              _vm._v(" "),
                              _c("td", [_vm._v(_vm._s(items.item.total_dias))]),
                              _vm._v(" "),
                              _c("td", [_vm._v(_vm._s(items.item.tipo))]),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      items.item.estado
                                        ? items.item.estado
                                        : items.item.id_estado == 70
                                        ? "Reprogramado Aprobado"
                                        : ""
                                    ) +
                                    "\n            "
                                )
                              ]),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      items.item.jefe &&
                                        (items.item.id_estado == 55 ||
                                          items.item.id_estado == 58 ||
                                          items.item.id_estado == 68 ||
                                          items.item.id_estado == 69)
                                        ? items.item.jefe
                                        : items.item.jefe_hijo &&
                                          (items.item.id_estado_hijo == 55 ||
                                            items.item.id_estado_hijo == 58 ||
                                            items.item.id_estado_hijo == 68 ||
                                            items.item.id_estado_hijo == 69) &&
                                          items.item.id_estado != 71 &&
                                          items.item.tipo != "R"
                                        ? items.item.jefe_hijo
                                        : ""
                                    ) +
                                    "\n            "
                                )
                              ]),
                              _vm._v(" "),
                              _c("td", { staticClass: "text-xs-center" }, [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(items.item.fecha_solicitud) +
                                    "\n            "
                                )
                              ]),
                              _vm._v(" "),
                              _c("td", { staticClass: "text-xs-center" }, [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(items.item.justificacion_rechazo) +
                                    "\n            "
                                )
                              ]),
                              _vm._v(" "),
                              _c(
                                "td",
                                { staticClass: "text-xs-center" },
                                [
                                  items.item.id_estado != 83 &&
                                  items.item.id_estado != 65
                                    ? _c(
                                        "v-chip",
                                        {
                                          attrs: {
                                            color:
                                              items.item.dias_faltantes > 0 &&
                                              items.item.tipo != "FR" &&
                                              items.item.tipo != "VC"
                                                ? "#00D092"
                                                : items.item.dias_faltantes <
                                                    0 &&
                                                  items.item.id_estado != 57 &&
                                                  items.item.id_estado != 65 &&
                                                  items.item.tipo != "FR" &&
                                                  items.item.tipo != "VC"
                                                ? "#d6232e"
                                                : items.item.dias_faltantes ==
                                                    0 &&
                                                  items.item.tipo != "FR" &&
                                                  items.item.tipo != "VC"
                                                ? "#00D092"
                                                : "",
                                            dark: "",
                                            "text-color": "wblackhite"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(
                                                items.item.dias_faltantes > 0 &&
                                                  items.item.tipo != "FR" &&
                                                  items.item.tipo != "VC"
                                                  ? "Falta " +
                                                      items.item
                                                        .dias_faltantes +
                                                      " días para hacer uso de su vacación"
                                                  : items.item.dias_faltantes <
                                                      0 &&
                                                    items.item.id_estado !=
                                                      57 &&
                                                    items.item.id_estado !=
                                                      65 &&
                                                    items.item.tipo != "FR" &&
                                                    items.item.tipo != "VC"
                                                  ? "Programación vencida"
                                                  : items.item.dias_faltantes ==
                                                      0 &&
                                                    items.item.tipo != "FR" &&
                                                    items.item.tipo != "VC"
                                                  ? "Hoy es la fecha del uso de su vacación"
                                                  : ""
                                              ) +
                                              "\n              "
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      items.item.entregado == "S"
                                        ? "ENTREGADO"
                                        : "NO ENTREGADO"
                                    ) +
                                    "\n            "
                                )
                              ]),
                              _vm._v(" "),
                              _c(
                                "td",
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      attrs: {
                                        color: "#3dca24",
                                        icon: "",
                                        title: "Ver detalle"
                                      },
                                      on: {
                                        click: function($event) {
                                          $event.preventDefault()
                                          return _vm.verDetalle(items.item)
                                        }
                                      }
                                    },
                                    [_c("v-icon", [_vm._v("remove_red_eye")])],
                                    1
                                  ),
                                  _vm._v(" "),
                                  items.item.id_estado == 57
                                    ? _c(
                                        "v-btn",
                                        {
                                          attrs: {
                                            color: "#44deaa",
                                            icon: "",
                                            title:
                                              "Ver detalle de reprogramaciones"
                                          },
                                          on: {
                                            click: function($event) {
                                              $event.preventDefault()
                                              return _vm.verReprogramaciones(
                                                items.item
                                              )
                                            }
                                          }
                                        },
                                        [_c("v-icon", [_vm._v("today")])],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  (items.item.id_estado == 72 ||
                                    items.item.id_estado == 70) &&
                                  _vm.bandera_fecha_corte
                                    ? _c(
                                        "v-btn",
                                        {
                                          attrs: {
                                            color: "#44deaa",
                                            icon: "",
                                            title:
                                              "Enviar solicitud de uso de vacación"
                                          },
                                          on: {
                                            click: function($event) {
                                              $event.preventDefault()
                                              return _vm.solicitarEjecucionVacacion(
                                                items.item
                                              )
                                            }
                                          }
                                        },
                                        [_c("v-icon", [_vm._v("send")])],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  (items.item.id_estado == 72 ||
                                    items.item.id_estado == 56) &&
                                  _vm.bandera_fecha_corte
                                    ? _c(
                                        "v-btn",
                                        {
                                          attrs: {
                                            color: "blue",
                                            icon: "",
                                            title: "Reprogramar"
                                          },
                                          on: {
                                            click: function($event) {
                                              $event.preventDefault()
                                              return _vm.reprogramarCronograma(
                                                items.item
                                              )
                                            }
                                          }
                                        },
                                        [_c("v-icon", [_vm._v("refresh")])],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  items.item.id_estado == 71 &&
                                  _vm.bandera_fecha_corte
                                    ? _c(
                                        "v-btn",
                                        {
                                          attrs: {
                                            color: "rgb(145,26,230)",
                                            icon: "",
                                            title: "Reprogramar reprogramación"
                                          },
                                          on: {
                                            click: function($event) {
                                              $event.preventDefault()
                                              return _vm.editarReprogramacionRechazada(
                                                items.item
                                              )
                                            }
                                          }
                                        },
                                        [_c("v-icon", [_vm._v("refresh")])],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  (items.item.id_estado == 65 ||
                                    items.item.id_estado == 55 ||
                                    items.item.id_estado == 58) &&
                                  items.item.tipo == "P"
                                    ? _c(
                                        "v-btn",
                                        {
                                          attrs: {
                                            color: "rgba( 36, 113, 163,0.7)",
                                            icon: "",
                                            title:
                                              "Ver reporte de programación de vacación"
                                          },
                                          on: {
                                            click: function($event) {
                                              $event.preventDefault()
                                              return _vm.verReporte(
                                                items.item,
                                                0
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _c("v-icon", [
                                            _vm._v("picture_as_pdf")
                                          ])
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  (items.item.id_estado == 65 ||
                                    items.item.id_estado == 55 ||
                                    items.item.id_estado == 58) &&
                                  items.item.tipo == "R"
                                    ? _c(
                                        "v-btn",
                                        {
                                          attrs: {
                                            color: "rgba( 36, 113, 163,0.7)",
                                            icon: "",
                                            title:
                                              "Ver reporte de reprogramación de vacación"
                                          },
                                          on: {
                                            click: function($event) {
                                              $event.preventDefault()
                                              return _vm.verReporte(
                                                items.item,
                                                1
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _c("v-icon", [
                                            _vm._v("picture_as_pdf")
                                          ])
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  items.item.id_estado == 57 &&
                                  (items.item.id_estado_hijo == 70 ||
                                    items.item.id_estado_hijo == 55 ||
                                    items.item.id_estado_hijo == 58 ||
                                    items.item.id_estado_hijo == 65 ||
                                    items.item.id_estado_hijo == 68 ||
                                    items.item.id_estado_hijo == 69)
                                    ? _c(
                                        "v-btn",
                                        {
                                          attrs: {
                                            color: "rgba( 142, 68, 173 ,0.7)",
                                            icon: "",
                                            title:
                                              "Ver reporte de reprogramaciones de vacación"
                                          },
                                          on: {
                                            click: function($event) {
                                              $event.preventDefault()
                                              return _vm.verReporte(
                                                items.item,
                                                2
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _c("v-icon", [
                                            _vm._v("picture_as_pdf")
                                          ])
                                        ],
                                        1
                                      )
                                    : _vm._e()
                                ],
                                1
                              )
                            ]
                          )
                        ]
                      }
                    }
                  ])
                },
                [_c("template", { slot: "buttons" })],
                2
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2cc414da", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2cc414da","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/vacacion_uso/Index.vue
// module id = null
// module chunks = 